import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import StudentID from 'components/fragments/StudentID/StudentID';
const StudentIDComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/StudentID/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <StudentID {...props} />
  </ImagesProvider>
);

export default StudentIDComponent;
